// src/pages/Dashboard.js — roteador puro por role.
//
// Este arquivo é só um dispatcher: pega o role do usuário no localStorage
// e devolve o componente de dashboard correspondente. NENHUM wrapper de
// layout aqui (AppSidebar, Box flex, TopBar) — cada dash específico já
// controla o próprio layout, e empilhar wrapper aqui virava BUG.
//
// Histórico: até ago/26 este arquivo tinha `<Box display=flex><AppSidebar/>
// <ContentComponent/></Box>`. Fazia sentido quando os dashes eram só o
// conteúdo interno. Depois os dashes ganharam AppSidebar próprio (pra
// funcionar standalone e resolver a topbar por role), mas ninguém removeu
// o wrapper daqui. Resultado: SupervisorDash e AgentDash (que renderiza
// dentro do SupervisorDash) tinham DUAS AppSidebars montadas ao mesmo
// tempo — ambas position:fixed no mesmo canto, uma colapsada e uma
// expandida, aparência de "menu duplicado" na tela. AdminDash não sofria
// disso porque tinha branch de early return separado. Fix é uniformizar:
// dashboard só roteia, dash monta o layout.
import { useEffect } from 'react';
import AgentDash from './dashboards/AgentDash';
import SupervisorDash from './dashboards/SupervisorDash';
import AdminDash from './dashboards/AdminDash';

export default function Dashboard() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role?.toUpperCase();

  // Proteção: se não tiver token, volta pro login
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      window.location.href = '/login';
    }
  }, []);

  // Sem user ainda / role indefinido → não renderiza nada (evita flash).
  if (!user || !role) return null;

  if (role === 'ADMIN') return <AdminDash />;
  if (role === 'SUPERVISOR') return <SupervisorDash />;
  return <AgentDash />;
}
